<template>
    <v-app>
        <router-view :key="$route.path"></router-view>
    </v-app>

</template>

<script>
	export default {
		name: "SimpleLayout"
	}
</script>

<style scoped>
body{
    background-color: #fff;
}
</style>
